import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  background: #f1f5f9;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: #232f3e;
  span {
    flex: 1;
    color: #fff;
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-weight: 600;
    text-transform: uppercase;
  }
`;

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  background: #fff;
  .ant-input-affix-wrapper {
    flex: 1;
    height: 56px;
    padding: 0 0 0 16px;
    border: 3px solid #2d6772;
    border-radius: 100px;
    overflow: hidden;
    input {
      font-family: Poppins;
      font-size: 16px;
    }
    input::placeholder {
      color: #adadad;
    }
    .ant-input-suffix {
      display: flex;
      width: 56px;
      height: 56px;
      margin: 0;
      align-items: center;
      justify-content: center;
      background: #2d6772;
    }
  }
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 8px;
  padding: 16px;
`;

export const StaffCard = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  position: relative;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;

  .name {
    color: #1d2129;
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  .check {
    position: absolute;
    top: 5px;
    right: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 100px;
    background: #2d6772;
    color: #fff;
  }

  &[data-active='true'] {
    border-color: #6fabb6;
    background: #c6e9ef;
    box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.4), 0 4px 8px 0 rgba(45, 35, 66, 0.3),
      0 -3px 0 0 #245963 inset;
  }
`;

export const Footer = styled.div`
  display: flex;
  padding: 16px 16px 24px;
  background: #fff;
  box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.15);
  .btn {
    display: flex;
    flex: 1 0 0;
    height: 56px;
    padding: 16px 24px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background: #e5e6eb;
    box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.4), 0 4px 8px -3px rgba(45, 35, 66, 0.3),
      0 -3px 0 0 #d6d6e7 inset;
    cursor: pointer;
    span {
      color: #1d2129;
      text-align: center;
      text-transform: uppercase;
      font-family: Poppins;
      font-size: 20px;
      font-weight: 600;
    }
  }
`;

export const EmptyText = styled.div`
  grid-column: 1 / -1;
  padding: 40px 0;
  text-align: center;
  color: #adadad;
  font-family: Poppins;
  font-size: 16px;
`;
